import { FieldValues } from 'react-hook-form'
import { ArrayFieldRemoveButton } from './ArrayFieldButtons'
import {
  ArrayFieldRowProvider,
  ArrayFieldRowProviderProps,
  useArrayFieldRowContext,
} from './ArrayFieldRowContext'

export type ArrayFieldRowProps<TFieldValues extends FieldValues = FieldValues> =
  ArrayFieldRowProviderProps<TFieldValues> & {
    RowContainer?: (props: { children: React.ReactNode; index: number }) => React.JSX.Element
  }

export function ArrayFieldRow<TFieldValues extends FieldValues = FieldValues>({
  children,
  field,
  index,
  RowContainer = Row,
}: ArrayFieldRowProps<TFieldValues>) {
  return (
    <ArrayFieldRowProvider field={field} index={index}>
      <RowContainer index={index}>{children}</RowContainer>
    </ArrayFieldRowProvider>
  )
}

function Row({ children, index }: { children: React.ReactNode; index: number }) {
  const { id } = useArrayFieldRowContext()

  return (
    <div
      className="flex w-full flex-row items-start gap-2"
      data-row-index={index}
      data-slot="array-field-row"
      id={id}
    >
      {children}
      <div className="pt-7.5">
        <ArrayFieldRemoveButton />
      </div>
    </div>
  )
}

export type ArrayFieldRowComponent<TFieldValues extends FieldValues = FieldValues> =
  typeof ArrayFieldRow<TFieldValues>
